/**
 * Utilidades de formateo para montos de token y fiat.
 * Usa TokenAmountConverter del domain (se migrará en Fase 4).
 */
import { TokenAmountConverter } from "domain/wallet/controllers/utils/TokenAmountConverter";

export function formatTokenAmount(bigToken: string, decimals: number): string {
    return TokenAmountConverter.formatToken(bigToken, decimals);
}

export function parseTokenAmount(token: string, decimals: number): string {
    return TokenAmountConverter.parseToken(token, decimals);
}

export function formatFiatAmount(token: string, decimals: number, price: number): string {
    const [priceInt, priceDecimals] = price.toString().split(".").concat("");
    const multSpaceDecimals = decimals + priceDecimals.length;
    const bigIntPrice = parseTokenAmount(priceInt + priceDecimals, multSpaceDecimals);
    const multResult = BigInt(token) * BigInt(bigIntPrice);
    return TokenAmountConverter.formatToken(multResult.toString(), multSpaceDecimals * 2);
}
